const AUTH_RECOVERY_SCREENS = new Set([
  'loading',
  'maintenance',
  'backendUnavailable',
  'playerUnavailable'
]);

export const screenAfterReadyAuth = currentScreen =>
  AUTH_RECOVERY_SCREENS.has(currentScreen) ? 'home' : currentScreen;
